<template>
  <layout name="LayoutDefault">
    <div class="Contact">
      <!-- Page Content -->
      <div class="container">
        <!-- Page Features -->
        <div class="contents">
          <div class="py-5">
            <div class="jumbotron bg-light text-center py-5">
              <!-- Heading -->
              <h2 class="text-success mb-3">
                আপনার অর্ডারটি গ্রহণ করা হয়েছে। আমাদের সাথে থাকার জন্য ধন্যবাদ।
              </h2>

              <p v-if="orderNo" class="mb-3">
                <strong>অর্ডার নম্বর: <span class="text-primary">{{ orderNo }}</span></strong>
              </p>

              <!-- Fine-print / return policy -->
              <p class="text-muted mb-4">
                আমাদের একজন প্রতিনিধি শীঘ্রই আপনার সাথে যোগাযোগ করবেন এবং অর্ডারটি নিশ্চিত করবেন।
              </p>

              <!-- Buttons -->
              <div class="d-flex justify-content-center">
                <a href="/" class="btn btn-danger mr-2">
                  Back Home
                </a>
                <a :href="orderId ? '/customer/dashboard/order/' + orderId : '/customer/dashboard'" class="btn btn-outline-danger">
                  Check Order Details
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.container -->
    </div>
  </layout>
</template>

<script>
import Layout from "../layouts/Layout";

export default {
  name: `Success`,
  components: {
    Layout,
  },
  data() {
    return {
      orderNo: null,
      orderId: null,
    };
  },
  mounted() {
    localStorage.setItem("cartCount", "0");
    $(".cart-count").text(0);
    this.orderNo = this.$route.query.order_no || null;
    this.orderId = this.$route.query.order_id || null;

    // Only fire Purchase when this is a real, just-completed checkout.
    // lastGrandTotal is set in Checkout.vue::placeOrder right before the COD/SSL redirect,
    // ONLY after the backend confirmed order_id. Consumed here on first mount.
    // → manual /success visits, F5 refreshes, stale bookmarks all skip.
    // → SSL flow works regardless of whether the gateway returns order_no/order_id in URL.
    const grandTotal = localStorage.getItem("lastGrandTotal");
    if (grandTotal && window.fbq) {
      fbq('track', 'Purchase', {
        value: grandTotal,
        currency: 'BDT'
      });
      localStorage.removeItem("lastGrandTotal");
    }
  },
};
</script>
